import React, {useCallback, useEffect, useState} from 'react';

import {Drawer, IconButton, withStyles} from '@material-ui/core';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import GroupAddIcon from '@material-ui/icons/GroupAdd';
import classNames from 'classnames';
import styles from './styles.js';

import {observer} from 'mobx-react-lite';
import {inject} from 'mobx-react';

import {buildUrlFotoPerfilLight} from '../../config/config';

import PageTitle from '../../components/PageTitle/PageTitle';
import Header from '../../template/Header/Header';
import Footer from '../../components/Footer/Footer';
import Profile from '../../template/Header/Profile';

import InputSearch from '../../components/Input/Input';
import debounce from 'lodash.debounce';

import ContactsList from './components/ContactsList';
import ChatContainer from './components/ChatContainer';
import CreateGrupoModal from './components/ChatGrupo/CreateGrupoModal';

import chatLogo from '../../assets/img/chat/chat-logo-health.png';
import Avatar from 'react-avatar';
import Notification from '../../components/Notification';
import AlertCard from '../../components/Cards/AlertCard';
import InfoIconFilled from '../../components/Icon/InfoIconFilled.js';

const isTablet = () => {
  const width = window.innerWidth;
  return width >= 700 && width <= 1400;
};

const Chat = observer(({ classes, chatStore, socketStore }) => {
  const { selectedContact, loggedUser, accessToken, notification, isDisconnected } = chatStore;
  const { contact } = selectedContact || {};
  const { isApiInitialized } = socketStore;
  
  const [openDrawer, setOpenDrawer] = useState(!isTablet());
  const [openCreateGrupo, setOpenCreateGrupo] = useState(false);

  useEffect(() => {
    if (!isApiInitialized) {
      return;
    }

    loadInitialData();
    if (!accessToken) {
      chatStore.getAccessToken();
    }
  }, []);

  const loadInitialData = async () => {
    const currentUnidadeId = await chatStore.getUnidadeLogadaId();
    await chatStore.getProfissionalSaudeAtual();

    if (currentUnidadeId !== chatStore.unidadeLogadaId) {
      chatStore.unidadeLogadaId = currentUnidadeId;
      chatStore.resetContacts();
      chatStore.selectedContact = null;
    }
  };

  const getSeletedContactProfilePic = () => {
    const { profissionalSaudeContato } = contact || {};
    const { fotoPerfil } = profissionalSaudeContato || {};

    if (fotoPerfil && accessToken) {
      return buildUrlFotoPerfilLight(fotoPerfil, accessToken);
    }

    return null;
  };

  const handleSearchContact = async (e) => {
    e.preventDefault();
    chatStore.resetContacts(chatStore.contactsPaginationSettings.ativo);
    await chatStore.getContacts();
  };

  const debounceSearch = useCallback(
    debounce((value) => {
      chatStore.contactInputSearch = value;
      chatStore.resetContacts(chatStore.contactsPaginationSettings.ativo);
      chatStore.getContacts();
    }, 500),
    []
  );

  const handleChangeSearchInput = (e) => {
    const value = e.target.value;
    chatStore.contactInputSearch = value;
    debounceSearch(value);
  };

  const renderUnselectedContent = () => {
    if (isDisconnected) {
      return (
        <AlertCard
          message={'Houve um problema com a sua conexão. A reconexão automática foi iniciada...'}
          width={'290px'}
          backgroundColor={'#FFF'}
          withLoadAnimation
          icon={
            <InfoIconFilled
              color="#FB7676"
              size={36}
            />
          }
        />
      );
    }
    return (
      <div className={classes.imageContainer}>
        <img src={chatLogo} alt='App Health Logo' />
      </div>
    );
  }

  const contactName = contact?.profissionalSaudeContato?.nome;

  useEffect(() => {
    return () => {
      chatStore.selectedContact = null;
      chatStore.willScrollToBottom = false;
    };
  }, []);

  const handleDrawerOpen = () => {
    setOpenDrawer(true);
  };

  const handleDrawerClose = () => {
    setOpenDrawer(false);
  };

  const showContactList = (isApiInitialized && loggedUser) || chatStore?.contacts?.length > 0;

  return (
    <div className={classNames(classes.gridChatContainer, !openDrawer && classes.gridChatContainerClose)}>
      <PageTitle title='Chat' />
      <div className={classes.sidebarLeft}>
        <Drawer
          variant="permanent"
          classes={{
            paper: classes.drawer,
          }}
          open={openDrawer}
        >
          {openDrawer && <div className={classes.sidebarHeader}>
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%' }}>
              <span className={classes.sideBarTitle}>Chat</span>
              {loggedUser?.tipo === 3 && (
                <IconButton
                  size="small"
                  onClick={() => setOpenCreateGrupo(true)}
                  title="Criar grupo"
                >
                  <GroupAddIcon style={{ color: '#219A97' }} />
                </IconButton>
              )}
            </div>
            <form
              className={classes.contactSearchForm}
              onSubmit={(e) => handleSearchContact(e)}
              id="cht-cht-frm-pes"

            >
              <InputSearch
                placeholder='Contatos'
                classes={{
                  inputRoot: classes.contactSearch,
                }}
                disabled={isDisconnected}
                onChange={(e) => handleChangeSearchInput(e)}
                value={chatStore.contactInputSearch}
                onClickSearch={(e) => handleSearchContact(e)}
                id="cht-cht-inp-pes"
              />
            </form>
          </div>}
          <div className={classes.contactList}>
            {showContactList && <ContactsList openDrawer={openDrawer}/>}
          </div>
          <IconButton
            aria-label={openDrawer ? "Close drawer" : "Open drawer"}
            onClick={openDrawer ? handleDrawerClose : handleDrawerOpen}
            className={classNames(classes.menuButton)}
          >
            {openDrawer ? (
              <>
                <ChevronLeftIcon />
                Minimizar barra lateral
              </>
            ) : (
              <ChevronRightIcon />
            )}
          </IconButton>
        </Drawer>
      </div>
      <div className={classes.content}>
        <Header>
          <div className={classes.contentHeader}>
            <div>
              {contact && (
                <div className={classes.selectedContact}>
                  <Avatar
                      round={true}
                      size={48}
                      name={contactName}
                      src={getSeletedContactProfilePic()}
                      maxInitials={2}
                    />
                  <span>{contactName}</span>
                </div>
              )}
            </div>
            <Profile />
          </div>
        </Header>
        {loggedUser && contact ? (
          <ChatContainer />
        ) : (
          <div className={classes.unselectedContact}>
            {renderUnselectedContent()}
          </div>
        )}
      </div>
      <Footer />
      <CreateGrupoModal
        open={openCreateGrupo}
        onClose={() => setOpenCreateGrupo(false)}
      />
      <Notification
        isOpen={notification.isOpen}
        variant={'error'}
        message={notification.message}
        close={() => chatStore.resetNotification()}
      />
    </div>
  );
});

const stores = ['chatStore', 'socketStore', 'googleAnalyticsStore'];
const ChatStyles = withStyles(styles)(Chat);
export default inject(...stores)(ChatStyles);
